import React, { useContext, useState } from 'react';
import PlayerInsightButton from '../../../PlayerInsightButton/PlayerInsightButton';
import Styles from './EmailInput.module.scss';
import { LocalizationContext } from '../../../../context/localizationContext';
import APIClient from '../../../../helpers/APIClient';

const EmailInput = (props) => {
  const localization = useContext(LocalizationContext);
  const { tileText } = localization;
  const { setEmailSubmit, setUserEmail, userEmail } = props;
  const [emailError, setEmailError] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);

  const registerEmail = () => {
    APIClient.userRegisterEmail(userEmail, (status) => {
      if (status === 200) {
        setEmailSubmit(true);
      } else {
        setEmailError(true);
        setSubmitBtnDisabled(false);
      }
    });
  };

  return (
    <div className={Styles.emailInputContainer}>
      <label className={Styles.emailInputLabel} htmlFor='email-input'>
        {tileText.emailText.inputLabel}
      </label>
      <input
        className={Styles.emailInput}
        type='email'
        id='email-input'
        onChange={(e) => setUserEmail(e.target.value)}
      />
      {emailError
        && (
          <div className={Styles.emailError}>
            {tileText.emailText?.emailErrorMessage}
          </div>
        )
      }
      <PlayerInsightButton
        label={tileText.emailText?.submitBtnText}
        onClick={() => {
          registerEmail();
          setSubmitBtnDisabled(true);
        }}
        disabled={submitBtnDisabled}
      />
      <div
        className={Styles.privacyStatement}
        dangerouslySetInnerHTML={{
          __html: tileText.emailText?.agreeToTerms,
        }}
      ></div>
    </div>
  );
};

export default EmailInput;
